import { useIntercom } from "react-use-intercom";

const useHandleBookACall = () => {
  const { show: openIntercom } = useIntercom();
  const handleBookACall = () => {
    // window.open(BOOK_A_CALL_LINK, "_blank");
    openIntercom();
  };

  return { handleBookACall };
};

export default useHandleBookACall;
